export default "__VITE_ASSET__BHaSxINm__"